import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { closeFoldout, openFilter } from '../../actions/filters';
import QueryFilter from '../../helpers/query-filter';
import { getActiveFacet, getQueryFilter } from '../../utils/reselectors';

interface FilterWxPanelProps {
  title: string;
  modifiers?: string;
  children?: React.ReactNode;
  onRequestSearch: (queryFilter: QueryFilter) => void;
}

const FilterWxPanel = ({ title, onRequestSearch, children, modifiers }: FilterWxPanelProps) => {
  const { t } = useTranslation(['common', 'search']);
  const dispatch = useDispatch();

  const facet = useSelector(getActiveFacet);
  const queryFilter = useSelector(getQueryFilter);

  const actions = bindActionCreators(
    {
      openFilter,
      closeFoldout,
    },
    dispatch,
  );

  const onCloseFoldout = () => actions.closeFoldout();
  const onReset = () => {
    if (facet) {
      let qf = queryFilter;
      qf = qf.remove(facet.id);
      qf = qf.removeRange(facet.id);
      qf = qf.removeSpatial();
      onRequestSearch(qf);
    }
  };

  const onClearFilters = () => {
    if (facet) {
      onReset();
    } else {
      onRequestSearch(new QueryFilter());
    }
  };

  return (
    <div data-wx-filterpanel={modifiers ? modifiers : ''}>
      <header className="filter-panel-header">
        <div className="filter-panel-header-action is-left">
          <button
            type="button"
            className="filter-panel-header-btn is-action"
            title={t('Clear filter', { ns: 'search' })}
            disabled={queryFilter.isEmpty()}
            onClick={onClearFilters}
          >
            <div className="filter-panel-header-btn-icon">
              <i className="icon-trash no-margin" />
            </div>
            <div className="filter-panel-header-btn-label">{t('Clear', { ns: 'common' })}</div>
          </button>
        </div>
        <div className="filter-panel-header-label">{title}</div>
        <div className="filter-panel-header-action is-right">
          <button
            type="button"
            className="filter-panel-header-btn"
            title={t('Close panel', { ns: 'common' })}
            onClick={onCloseFoldout}
          >
            <div className="filter-panel-header-btn-icon is-big">
              <i className="icon-close no-margin" />
            </div>
          </button>
        </div>
      </header>
      <div className="filter-panel-body">{children}</div>
    </div>
  );
};

export default FilterWxPanel;
